<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-08-01 14:44:46
 * @LastEditTime: 2023-03-23 14:38:37
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" :model="dataForm" :rules="formRules" autocomplete="off" scrollToFirstError>
    <dc-layout-card :title="t('common.baseTitle')" :span="6">
      <dc-form-item name="customerName" :label="t('clue.customerName')">
        <CosInput
          v-model:value="dataForm.customerName"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="customerName" :label="t('clue.clueId')" v-if="props.type === 'view'">
        <CosInput v-model:value="dataForm.clueId" :disabled="!props.isEdit" view />
      </dc-form-item>
      <dc-form-item name="channel" :label="t('clue.clueChannel')" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="dataForm.channel"
            :cosDes="dataForm.channelExplain"
            appId="cos_ofbu"
            paramCode="ofbu_source_channel"
            :status="props.type === 'view' ? undefined : 0"
            :disabled="!props.isEdit"
            :view="props.type === 'view'"
            style="width: 33%"
          />
          <dc-form-item name="channelExplain" :span="24" style="width: 67%" class="last-compact">
            <CosInput
              v-model:value="dataForm.channelExplain"
              :maxlength="100"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item name="clueType" :label="t('clue.clueType')">
        <CosSelect
          v-model:value="dataForm.clueType"
          :options="clueTypeEnumComputed"
          :disabled="!props.isEdit || props.clueTypeDisabled"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        name="customerOffice"
        :label="t('clue.customerOffice')"
        :rules="formRules.customerOffice"
      >
        <CustomerArea
          v-model:value="dataForm.customerOffice"
          change-on-select
          showSearch
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="customerWebsite" :label="t('clue.officialWeb')">
        <CosInput
          v-model:value.trim="dataForm.customerWebsite"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="registerEmail" :label="t('clue.regEmail')">
        <CosInput
          v-model:value.trim="dataForm.registerEmail"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="customerAddress" :label="t('clue.customerAddress')">
        <CosInput
          v-model:value.trim="dataForm.customerAddress"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="activityQrcodeId" :label="t('clue.marketActivity')"
                    :rules="[{ required: marketRequired, message: t('common.pleaseSelect') }]">
        <CosSelect
          v-model:value="dataForm.activityQrcodeId"
          :options="marketOptions"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          optionFilterProp="label"
          showSearch
        />
      </dc-form-item>
      <dc-form-item name="customerRegion" :label="t('clue.customerRegion')">
        <CustomerAreaCascader
          appId="cos_ofbu"
          v-model:value="dataForm.customerRegion"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="6" v-if="props.type !== 'view'">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('clue.estAveRevenue')"
            :name="['business', 'annualSales']"
          >
            <CosInputNumber
              v-model:value="dataForm.business.annualSales"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="props.type === 'view'"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="annualSalesUnit"
            style="width: 30%"
            :name="['business', 'annualSalesUnit']"
            class="hide-label"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.business.annualSalesUnit"
              :view="props.type === 'view'"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('clue.estAveRevenue')"
        :name="['business', 'annualSalesUnit']"
      >
        <ParamCodesSelect
          :cosBeforeDes="dataForm.business?.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.business.annualSalesUnit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.clientType')"
        name="clientType"
      >
        <ParamCodesSelect
          :options="paramCodeData.ofbu_client_type"
          v-model:value="dataForm.clientType"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.salesChannel')"
        :name="['business', 'salesChannel']"
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.ofbu_sales_channel"
          v-model:value="dataForm.business.salesChannel"
          :view="props.type === 'view'"
          :disabled="!props.isEdit"
        />
      </dc-form-item>
      <dc-form-item
        name="futureContactTime"
        :label="t('clue.futureContactTime')"
        :rules="clueType ? formRules.futureContactTime : []"
        v-if="clueType"
      >
        <CosSingleDateTimePicker
          isOutputBeijingTime
          v-model:startTime="dataForm.futureContactTime"
          :isRange="false"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="follower" :label="t('clue.followerName')">
        <UserSelect
          v-model:value="dataForm.follower"
          defaultValue="me"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          @change="handleFollowerChange"
        />
      </dc-form-item>
      <dc-form-item
        name="invalidId"
        :label="t('clue.invalidReason')"
        :rules="invalidClue ? formRules.invalidId : []"
        v-if="dataForm.clueType === 3"
      >
        <ParamCodesSelect
          v-model:value="dataForm.invalidId"
          :options="paramCodeData.ofbu_invalid_reason"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <template v-if="!props.isEdit">
        <dc-form-item name="createByName" :label="t('common.createByName')">
          <CosInput v-model:value="dataForm.createByName" view />
        </dc-form-item>
      </template>
      <template v-if="!props.isEdit">
        <dc-form-item name="createTime" :label="t('common.createTime')">
          <CosInput v-model:value="dataForm.createTime" view />
        </dc-form-item>
      </template>
    </dc-layout-card>

    <dc-layout-card :title="t('common.concatInfo')" :span="6">
      <dc-form-item
        v-if="props.type === 'view'"
        :label="t('common.contactName')"
        :name="['contact', 'lastName']"
        :rules="formRules.lastName"
      >
        <CosInput v-model:value="dataForm.contact.name" :view="props.type === 'view'" />
      </dc-form-item>
      <a-col v-else :span="6">
        <div class="flex cos-both-form-item">
          <a-form-item :span="24" :label="t('common.firstName')" style="width: 50%">
            <CosInput v-model:value="dataForm.contact.firstName" :maxlength="50" />
          </a-form-item>
          <a-form-item
            :label="t('common.lastName')"
            :name="['contact', 'lastName']"
            style="width: 50%"
            class="last-compact"
            :rules="formRules.lastName"
          >
            <CosInput v-model:value="dataForm.contact.lastName" :maxlength="50" />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item :label="t('common.mobile')" :name="['contact', 'mobileRegion']" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodesSelect
            v-model:value="dataForm.contact.mobileRegion"
            :options="paramCodeData.ofbu_area_code"
            :disabled="!props.isEdit"
            :view="props.type === 'view'"
            :cosDes="dataForm.contact.mobile"
            allowClear
            style="width: 33%"
          />
          <dc-form-item
            :span="24"
            style="width: 67%"
            :name="['contact', 'mobile']"
            :rules="{
              validator: (rule:any, value:any) => ofbuContactValidate(rule, value, dataForm.contact, formRef)
            }"
            class="last-compact"
          >
            <CosInput v-model:value="dataForm.contact.mobile" :disabled="!props.isEdit" :view="props.type === 'view'" />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        :label="t('common.skype')"
        :name="['contact', 'skype']"
        :rules="{
              validator: (rule:any, value:any) => ofbuContactValidate(rule, value, dataForm.contact, formRef)
            }"
      >
        <CosInput
          v-model:value="dataForm.contact.skype"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('common.email')"
        :name="['contact', 'email']"
        :rules="{
              validator: (rule:any, value:any) => ofbuContactValidate(rule, value, dataForm.contact, formRef)
            }"
      >
        <CosInput
          v-model:value="dataForm.contact.email"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('common.jobRole')" :name="['contact', 'tel']">
        <CosSelect
          v-model:value="dataForm.contact.jobRole"
          :options="linkRoleTypeEnum"
          :disabled="!props.isEdit"
          allowClear
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('common.jobDuty')" :name="['contact', 'jobDuty']">
        <CosInput
          v-model:value="dataForm.contact.jobDuty"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('common.sex')" :name="['contact', 'sex']">
        <CosRadioGroup v-model:value="dataForm.contact.sex" :options="genderEnum" :view="props.type === 'view'" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item :label="t('common.remark')" :name="['contact', 'remark']" :span="12">
        <CosTextarea
          v-model:value="dataForm.contact.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>

    <!-- 仓储服务3438, 头程+仓储3441 -->
    <dc-layout-card :title="t('clue.业务需求')" :span="6">
      <dc-form-item
        :label="t('clue.业务类型')"
        :name="['business', 'businessTypeSelect']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.businessTypeSelect"
          :options="paramCodeData.ofbu_business_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.服务标准')"
        :name="['business',  'servicesStandard']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.servicesStandard"
          :options="paramCodeData.ofbu_services_standard"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.销售平台')"
        :name="['business', 'salePlatform']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.salePlatform"
          :options="paramCodeData.ofbu_sale_platform"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.发货量(月)')"
        :name="['business',  'shipments']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.shipments"
          :options="paramCodeData.ofbu_shipments"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.产品分类')"
        :name="['business', 'salesCategory']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.salesCategory"
          :options="paramCodeData.ofbu_sales_category"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.产品尺寸')"
        :name="['business', 'cargoType']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.cargoType"
          :options="paramCodeData.ofbu_product_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'orderTypeDistribution']" :label="t('clue.订单类型分布')">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('common.订单类型分布输入提示')}}</p>
            </template>
            <span>{{t('clue.订单类型分布')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value.trim="dataForm.business.orderTypeDistribution"
          :maxlength="200"
          :disabled="!props.isEdit"
          :placeholder="t('common.订单类型分布输入提示')"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'productValue']" :label="t('clue.热销品价值(USD)')">
        <CosInput
          v-model:value.trim="dataForm.business.productValue"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'orderDistribution']" :label="t('clue.单品多品订单比例')">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('common.单品多品订单比例输入提示')}}</p>
            </template>
            <span>{{t('clue.单品多品订单比例')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value.trim="dataForm.business.orderDistribution"
          :maxlength="200"
          :disabled="!props.isEdit"
          :placeholder="t('common.单品多品订单比例输入提示')"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'skuType']" :label="t('clue.SKU种类')">
        <CosInput
          v-model:value.trim="dataForm.business.skuType"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.SKU单位')"
        :name="['business', 'skuUnit']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.skuUnit"
          :options="paramCodeData.ofbu_sku_unit"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.尾程服务需求')"
        :name="['business', 'serviceType']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.serviceType"
          :options="paramCodeData.ofbu_service_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.区域仓')"
        :name="['business', 'regionalWarehouse']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.regionalWarehouse"
          :options="paramCodeData.ofbu_demand_info"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.入库包装方式')"
        :name="['business', 'inboundPackageType']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.inboundPackageType"
          :options="paramCodeData.ofbu_inbound_package_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'averageInventoryVolume']" :label="t('clue.平均在库体积')">
        <CosInput
          v-model:value.trim="dataForm.business.averageInventoryVolume"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'firstInboundTime']"
        :label="t('clue.预计第一次来货时间')"
      >
        <CosSingleDateTimePicker
          isOutputBeijingTime
          v-model:startTime="dataForm.business.firstInboundTime"
          :isRange="false"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'futureIncrement']" :label="t('clue.未来增量(月订单)')">
        <CosInput
          v-model:value.trim="dataForm.business.futureIncrement"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'systemIntegration']" :label="t('clue.系统对接需求')">
        <CosInput
          v-model:value.trim="dataForm.business.systemIntegration"
          :maxlength="200"
          :disabled="!props.isEdit"
          :placeholder="t('common.系统对接需求输入提示')"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('clue.其他附件')" name="otherFile" :span="24">
        <UploadFile :view="props.type === 'view'" v-model:value="dataForm.business.otherFile" valueType="array" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card :title="t('clue.报价')" :span="6">
      <template #subTitle v-if="props.isEdit&&quotationAndBusinessChange">
        <a-button type="primary" ghost @click="handleQuotationAdd()">{{ t('btn.add') }}</a-button>
      </template>
      <dc-form-item
        :label="t('clue.价格类型')"
        :name="['business','quotationInfo', 'quotationType']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.quotationInfo.quotationType"
          :options="paramCodeData.ofbu_quotation_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        v-if="quotationAndBusinessChange"
        :name="['business', 'quotationInfo', 'fulfillmentRatesVersion']"
        :label="t('clue.仓储报价版本')">
        <CosInput
          v-model:value.trim="dataForm.business.quotationInfo.fulfillmentRatesVersion"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        v-if="quotationAndBusinessChange"
        :name="['business', 'quotationInfo', 'shippingRatesVersion']"
        :label="t('clue.尾程报价版本')">
        <CosInput
          v-model:value.trim="dataForm.business.quotationInfo.shippingRatesVersion"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <!-- 当【价格类型】选择为【定制价 id3469】时，显示该字段并必填 -->
      <!-- 公布价 id3468 -->
      <dc-form-item
        v-if="dataForm.business.quotationInfo.quotationType === 3469"
        :name="['business', 'quotationInfo', 'priceDocuments']"
        :label="t('clue.报价策略')"
        :rules="{ required: dataForm.business.quotationInfo.quotationType === 3469, message: t('common.pleaseInput') }"
      >
        <CosInput
          v-model:value.trim="dataForm.business.quotationInfo.priceDocuments"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <MultipleItem :view="props.type === 'view'"  v-if="quotationAndBusinessChange">
        <a-col :span="24">
          <p style="font-weight: bold;padding-bottom:4px">{{ `${t('clue.区域仓')}${index+1}` }}</p>
        </a-col>
        <template v-for="(item, index) in dataForm.business.quotationInfo.details" :key="index">
          <dc-form-item
            :label="t('clue.区域仓')"
            :span="3"
            :name="['business', 'quotationInfo', 'details', index, 'regionalWarehouse']"
          >
            <ParamCodesSelect
              v-model:value="item.regionalWarehouse"
              :options="paramCodeData.ofbu_demand_info"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'subWarehouseCode']" :label="t('clue.物理仓')" :span="3">
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>Warehouse Management Team will confirm in OA</p>
                </template>
                <span>{{t('clue.物理仓')}}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
              </a-tooltip>
            </template>
            <CosInput
              v-model:value.trim="item.subWarehouseCode"
              :maxlength="200"
              disabled
              ignorePlaceHolder
              :view="props.type === 'view'"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'storageFeeDiscount']" :label="t('clue.仓租折扣(%)')" :span="3">
            <CosInput
              v-model:value.trim="item.storageFeeDiscount"
              :maxlength="200"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'handingFeeDiscount']" :label="t('clue.操作费折扣(%)')" :span="3">
            <CosInput
              v-model:value.trim="item.handingFeeDiscount"
              :maxlength="200"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'shippingFeeDiscount']" :label="t('clue.尾程折扣(%)')" :span="3">
            <CosInput
              v-model:value.trim="item.shippingFeeDiscount"
              :maxlength="200"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'remark']" :label="t('common.remark')" :span="6">
              <CosInput
                v-model:value="item.remark"
                :maxlength="2000"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
              />
          </dc-form-item>
          <dc-form-item v-if="
                  props.isEdit &&
                  dataForm.business.quotationInfo.details &&
                  dataForm.business.quotationInfo.details.length > 1
                " :span="3">
            <a-button
              type="text"
              danger
              style="padding: 0 0 0 12px"
              @click="handleQuotationDel(index)"
            >{{ t('btn.del') }}</a-button
            >
          </dc-form-item>
        </template>
      </MultipleItem>
      <dc-form-item :label="t('clue.客户报价/竞对报价')" :name="['business', 'quotationInfo', 'competitorPriceDocuments']" :span="24">
        <UploadFile :view="props.type === 'view'" v-model:value="dataForm.business.quotationInfo.competitorPriceDocuments" valueType="array" />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card :title="t('clue.合同和账期')" :span="6">
      <dc-form-item
        :label="t('clue.服务公司')"
        :name="['business', 'contractInfo', 'serviceCompany']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.contractInfo.serviceCompany"
          :options="paramCodeData.ofbu_service_body"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.付款方式')"
        :name="['business', 'contractInfo', 'paymentType']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.contractInfo.paymentType"
          :options="paramCodeData.ofbu_payment_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.出账周期(天)')"
        :name="['business', 'contractInfo', 'billingTerm']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.contractInfo.billingTerm"
          :options="paramCodeData.ofbu_billing_term"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <!-- 当【付款方式】选择为【额度 3504】时，显示该字段，非必填,当【付款方式】选择为【账期 3473】时，显示该字段，且必填 -->
      <dc-form-item
        v-if="dataForm.business.contractInfo.paymentType === 3504
         || dataForm.business.contractInfo.paymentType === 3473"
        :name="['business', 'contractInfo', 'paymentTerm']"
        :label="t('clue.付款周期(天)')"
        :rules="{ required: dataForm.business.contractInfo.paymentType === 3473, message: t('common.pleaseInput') }"
      >
        <CosInput
          v-model:value.trim="dataForm.business.contractInfo.paymentTerm"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <!-- 当【付款方式】选择为【额度】时，显示该字段并必填 -->
      <a-col :span="6" v-if="props.type !== 'view' && dataForm.business.contractInfo.paymentType === 3504">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('clue.固定额度')"
            :name="['business', 'contractInfo', 'fixedCredit', 'amount']"
            :rules="{ required: dataForm.business.contractInfo.paymentType === 3504, message: t('common.pleaseInput') }"
          >
            <CosInputNumber
              v-model:value="dataForm.business.contractInfo.fixedCredit.amount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="props.type === 'view'"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="fixedCreditCurrency"
            style="width: 30%"
            :name="['business', 'contractInfo', 'fixedCredit', 'currency']"
            class="hide-label"
            :rules="{ required: dataForm.business.contractInfo.paymentType === 3504, message: t('common.pleaseSelect') }"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.business.contractInfo.fixedCredit.currency"
              :view="props.type === 'view'"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-if="props.type === 'view' && dataForm.business.contractInfo.paymentType === 3504"
        :label="t('clue.固定额度')"
        :name="['business', 'contractInfo', 'fixedCredit', 'currency']"
        :rules="[{ required: dataForm.business.contractInfo.paymentType === 3504, message: t('common.pleaseSelect') }]"
      >
        <ParamCodesSelect
          :cosBeforeDes="dataForm.business.contractInfo.fixedCredit.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.business.contractInfo.fixedCredit.currency"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="6" v-if="props.type !== 'view'">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('clue.系统注册费')"
            :name="['business', 'contractInfo', 'registrationFee', 'amount']"
          >
            <CosInputNumber
              v-model:value="dataForm.business.contractInfo.registrationFee.amount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="props.type === 'view'"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="registrationFeeCurrency"
            style="width: 30%"
            :name="['business', 'contractInfo', 'registrationFee', 'currency' ]"
            class="hide-label"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.business.contractInfo.registrationFee.currency"
              :view="props.type === 'view'"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('clue.系统注册费')"
        :name="['business', 'contractInfo', 'registrationFee', 'currency']"
      >
        <ParamCodesSelect
          :cosBeforeDes="dataForm.business.contractInfo.registrationFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.business.contractInfo.registrationFee.currency"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="6" v-if="props.type !== 'view'">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('clue.系统管理月费')"
            :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'amount']"
          >
            <CosInputNumber
              v-model:value="dataForm.business.contractInfo.monthlyMaintenanceFee.amount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="props.type === 'view'"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="monthlyMaintenanceFeeCurrency"
            style="width: 30%"
            :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']"
            class="hide-label"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.business.contractInfo.monthlyMaintenanceFee.currency"
              :view="props.type === 'view'"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('clue.系统管理月费')"
        :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']"
      >
        <ParamCodesSelect
          :cosBeforeDes="dataForm.business.contractInfo.monthlyMaintenanceFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.business.contractInfo.monthlyMaintenanceFee.currency"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.客户特殊服务')"
        :name="['business', 'contractInfo', 'additionalServices']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.contractInfo.additionalServices"
          :options="paramCodeData.ofbu_service_demand"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'contractInfo', 'legalSystemApplicationNo']" :label="t('clue.法务流程编码')">
        <CosInput
          v-model:value.trim="dataForm.business.contractInfo.legalSystemApplicationNo"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item name="remark" :label="t('common.remark')" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>

  <cos-footer-button
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="resetValue"
    :loading="loading"
    :disabled="!props.isEdit"
    :permissionPage="permissionPage"
    @submit="handleSubmit"
  />
</template>

<script setup lang="ts">
import { ref, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
import { ofbuContactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import CustomerArea from '@/components/CustomerArea'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { clueTypeEnum } from '@/views/overseasSales/clueManage/dataConfig'
import { linkRoleTypeEnum, genderEnum, flagEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes, fetchUsersByWorkCode } from '@/api/common'
import { salesClueCreate, salesClueActivate, salesClueEdit, salesClueDetail } from '@/api/overseasSales/clueManage'
import calc from '@/utils/calc'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { clear } from '@/hooks/addressArrValidate'
import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
import { getTreeIds } from '@/utils/index'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const props = defineProps({
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  clueTypeDisabled: {
    type: Boolean,
    default: false
  },
  resetValue: {
    type: [Object, Array]
  }
})

const permissionPage = computed(() => {
  return props.type === 'add'
    ? { save: 'ofbu_clue_add_btn' }
    : { edit: 'ofbu_clue_edit_btn', save: 'ofbu_clue_edit_btn' }
})
const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business:
    {
      demandInfo:
        { warehouses: [{}] },
      saleInfo: [{}],
      quotationInfo: { details: [{}] },
      contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
    },
  visitAddress: [{}]
})

const queryClueId = computed(() => route.query.clueId as string)
// 线索类型枚举
const clueTypeEnumComputed = computed(() => {
  const addList = clueTypeEnum.filter((item) => item.value === 1 || item.value === 2)
  const otherList = clueTypeEnum.filter((item) => item.value)
  return props.type === 'add' ? addList : otherList
})
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_invalid_reason: [], // 无效原因
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_area_code: [], // 手机区号
  ofbu_service_demand: [], // 服务需求
  ofbu_important: [], // 潜在收入
  ofbu_client_type: [], // 客户类型
  ofbu_business_type: [], // 客户业务类型
  ofbu_demand_info: [], // 需求海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 产品货型
  ofbu_currency: [], // 币种
  ofbu_sales_channel: [], // 销售渠道
  ofbu_services_standard: [], // 服务标准
  ofbu_shipments: [], // 发货量（月）
  ofbu_sku_unit: [], // SKU单位
  ofbu_quotation_type: [], // 价格类型
  ofbu_service_type: [], // 尾程服务需求
  ofbu_service_body: [], // 服务主体（服务公司）
  ofbu_payment_type: [], // 付款方式
  ofbu_billing_term: [], // 出账周期
  ofbu_inbound_package_type: [] // 入库包装方式
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_invalid_reason',
      'ofbu_marketing_activity',
      'ofbu_area_code',
      'ofbu_service_demand',
      'ofbu_important',
      'ofbu_client_type',
      'ofbu_business_type',
      'ofbu_demand_info',
      'ofbu_sale_platform',
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_sign_in_address_label',
      'ofbu_currency',
      'ofbu_sales_channel',
      'ofbu_services_standard',
      'ofbu_shipments',
      'ofbu_sku_unit',
      'ofbu_quotation_type',
      'ofbu_service_type',
      'ofbu_service_body',
      'ofbu_payment_type',
      'ofbu_billing_term',
      'ofbu_inbound_package_type',
      'ofbu_source_channel'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
onBeforeMount(() => {
  getByParamCodes()
  getMarketOption()
})
// 获取当前用户的信息
const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.fbuCustomerRegion != null) {
      dataForm.customerRegion = followerInfo.fbuCustomerRegion
    } else {
      dataForm.customerRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('customerRegion'))
    }
  })
}

const formRef = ref<FormInstance>()
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueType = ref(false)
const marketRequired = ref<boolean>()
const invalidClue = ref(false)
const isPerfect = ref(false)
const marketOptions = ref<any[]>([])
const formRules: Record<string, Rule[]> = {
  select: [{ required: true, message: t('common.pleaseSelect') }],
  input: [{ required: true, message: t('common.pleaseInput') }],
  channel: [{ required: true, message: t('common.pleaseSelect') }],
  clueType: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  customerOffice: [{ required: true, message: t('common.pleaseSelect') }],
  futureContactTime: [{ required: true, message: t('common.pleaseSelect') }],
  follower: [{ required: true, message: t('common.pleaseSelect') }],
  customerName: [{ required: true, message: t('common.pleaseInput') }],
  industrialBeltName: [{ required: true, message: t('common.pleaseInput') }],
  invalidId: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  contactType: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  lastName: [
    { required: true, message: t('common.pleaseInput') },
    {
      validator: concatNameValidate
    }
  ],
  contact: [{ validator: (rule: any, value: any) => ofbuContactValidate(rule, value, dataForm, formRef.value) }]
}
watch(
  () => route.query.isPerfect,
  (val) => {
    if (val === 'required') {
      isPerfect.value = true
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.clueType,
  (val) => {
    // 控制未来线索必填校验
    if (val === 1) {
      clueType.value = true
    } else {
      clueType.value = false
      dataForm.futureContactTime = undefined
    }

    // 控制无效线索必填校验
    if (val === 3) {
      invalidClue.value = true
    } else {
      invalidClue.value = false
      dataForm.invalidId = undefined
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.channel,
  (val) => {
    // 目前当【线索来源】选择【市场活动1809、市场投放1811、市场渠道（合作伙伴）1810】时，关联市场该字段必填
    // 但是线索来源是属于层级的，该三个来源下还有一层，无法全部判断，故此处就只判断非必填的状态
    if (val) {
      const labelIds = getTreeIds(paramCodeData.ofbu_source_channel || [], val)
      marketRequired.value = labelIds.includes(1809) || labelIds.includes(1810) || labelIds.includes(1811)
    } else {
      marketRequired.value = false
    }
  },
  { immediate: true }
)
watch(
  () => props.value,
  (val) => {
    if (val) {
      // 处理后端返回 null、0、空数组的问题
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      // 处理需求海外仓和totalAmount 把0=》undefined
      if (!formVal.business.demandInfo.totalAmount) {
        formVal.business.demandInfo.totalAmount = undefined
      }
      if (formVal.business.demandInfo.warehouses.length) {
        formVal.business.demandInfo.warehouses.forEach((item: any) => {
          if (!item) return
          if (item.warehouseId != null) {
            item.warehouseId = item.warehouseId || undefined
          }
          if (item.amount === null) item.amount = undefined
        })
      }
      if (formVal.business.saleInfo.length) {
        formVal.business.saleInfo.forEach((item: any) => {
          if (!item) return
          if (item.salePlatformId != null) {
            item.salePlatformId = item.salePlatformId || undefined
          }
          if (item.percent === null) item.percent = undefined
        })
      }
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  { immediate: true, deep: true }
)
const handleFollowerChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}

const checkValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error(message))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  let key = list[index][name]
  if (name === 'warehouseId' && key === -9) key = undefined
  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}
const percentValidate = async (rule: any, value: number) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error(t('common.pleaseInput')))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const key = dataForm.business.saleInfo?.[index].salePlatformId
  if (key && key !== -9 && value == null) {
    return Promise.reject(new Error(t('common.pleaseInput')))
  }
  const result = dataForm.business.saleInfo?.reduce((prev: number, curr: any) => calc.Add(prev, curr.percent || 0), 0)
  if (value && result !== 100) {
    return Promise.reject(new Error(t('clue.saleInfoPercentValidate')))
  } else {
    return Promise.resolve()
  }
}

const amount = computed(() => {
  const result = dataForm.business.demandInfo.warehouses?.reduce((sum, item) => {
    return calc.Add(sum, item.amount || 0)
  }, 0)
  return result || ''
})
const handleQuotationAdd = () => {
  dataForm.business.quotationInfo?.details?.push({ })
}
const handleQuotationDel = (index: number) => {
  dataForm.business.quotationInfo?.details?.splice(index, 1)
}
const quotationAndBusinessChange = ref<boolean>(false)

watch(
  () => dataForm.business.contractInfo?.paymentType,
  (newValue, oldValue) => {
    if (newValue === 3504 || newValue === 3473) {
      if (!dataForm.business.contractInfo.paymentTerm) {
        dataForm.business.contractInfo.paymentTerm = '10'
      }
    }
  },
  { immediate: true, deep: true }
)
// 当【价格类型】选择为【公布价】且【业务类型】选择为【仓储服务】或【头程+仓储】时
watch(
  () => [dataForm.business.quotationInfo.quotationType, dataForm.business.businessTypeSelect],
  (newValue, oldValue) => {
    const [quotationType, businessTypeSelect] = newValue
    quotationAndBusinessChange.value = (quotationType === 3468) &&
      (businessTypeSelect === 3438 || businessTypeSelect === 3441)
  },
  { immediate: true, deep: true }
)
const loading = ref(false)
const handleSubmit = async () => {
  try {
    loading.value = true
    const params = cloneDeep(dataForm)
    const { visitAddress } = params
    params.visitAddress = clear(visitAddress, ['addressName', 'geoPoint'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(params.visitAddress) === '[{}]') {
      params.visitAddress = { attrList: [] }
    } else {
      params.visitAddress = { attrList: params.visitAddress }
    }
    // 联系方式为空的字段需要删除，否则接口会报错
    // for (const key in params.contact) {
    //   if (params.contact[key] === '' || params.contact[key] == null) delete params.contact[key]
    // }
    params.business.demandInfo.warehouses = params.business.demandInfo.warehouses?.filter((item: any) => {
      return item.warehouseId != null && item.amount != null
    })
    params.business.saleInfo = params.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    // 清空产业带名称
    if (params.business.industrialBeltFlag !== 1) {
      params.business.industrialBeltName = ''
    }
    if (params.business.businessTypeSelect) {
      params.business.businessType = [params.business.businessTypeSelect]
      params.business.businessTypeSelect = undefined
    }
    if (queryClueId.value) {
      params.id = queryClueId.value
      if (params.customerRegion === undefined) {
        params.customerRegion = ''
      }
      await salesClueEdit(params)
      message.success(t('tips.editSuccess'))
      goBack()
    } else {
      const data = await salesClueCreate(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success(t('tips.addSuccess'))
        goBack()
      } else if (data.code === 13000059) {
        DcConfirm.warning({
          title: t('tips.beNotified'),
          content: data.message,
          cancelText: t('btn.cancel'),
          okText: t('btn.continue'),
          onOk() {
            salesClueActivate(params).then(() => {
              message.success(t('clue.claimedSuccess'))
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    }
  } catch (errorInfo: any) {
    loading.value = false
    formRef.value?.scrollToField(errorInfo.errorFields[0].name.toString())
  }
  loading.value = false
}
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>

<style lang="scss" scoped>
:deep(.form-item_compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
:deep(.last-compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
</style>
